import { styled } from '@mui/material'

export const ModalImage = styled('img')(({ theme }) => ({
  width: '100%',
  borderRadius: '15px',
  objectFit: 'cover',
  [theme.breakpoints.down('sm')] : {
    borderRadius: '50%',
    width: '100px',
    height: '100px',
  }
}))

export const ModalButton = styled('a')(({ theme }) => ({
  display: 'flex',
  textDecoration: 'none',
  marginTop: '-20px',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '10px',
  '& >button': {
    width: '100%',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'white',
    padding: '8px',
    fontSize: 'calc(min(3vw, 1.5rem))',
    boxShadow: '2px 2px 10px 0.2px gray',
    '&:hover': {
      backgroundColor: 'white',
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
  },
}))

export const StyledButtonContainer = styled('div')(({ theme }) => ({
    position: 'sticky',
    width: '100%',
    bottom: '50px',
    marginBottom: '20px'
}));

//  Issue: gray COVID-19 banner overlaps provider modal if not scrolled out of view. 
// Caused by React app integration with WordPress. Z-index adjustments don't help. Rare but possible occurrence.
export const ModalContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '70%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.5)',
  padding: '20px',
  borderRadius: 6,
  maxHeight: 'auto',
  zIndex: '3',
  overflowY: 'auto',
  [theme.breakpoints.down('md')]: {
    width: '60%',
    maxHeight: '90%',
  },
  [theme.breakpoints.up('md')]: {
    width: '60%',
    maxHeight: '90%',
  },
  [theme.breakpoints.down('sm')]: {
    maxHeight: '100%',
    padding: '10px',
    width: '75%',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    maxHeight: '90%',
  }

}))

export const ProviderInfoContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    margin: '25px',
  },
}))

export const NoScrollbar = styled('div')(() => ({
  overflow: 'hidden',
  '& ::-webkit-scrollbar': {
    display: 'none',
  },
  '& ::-webkit-scrollbar-thumb': {
    display: 'none',
  },
  scrollbarWidth: 'none',
}))
